import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import PestControlIndustry from "@/pages/industries/PestControlIndustry";
export const Route = createFileRoute("/industries/pest-control")({ head: ({match}) => pageHead(match.pathname), component: () => (<PestControlIndustry />) });
